import React from "react";

const Download: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" fill="none" viewBox="0 0 20 18">
            <path
                fill="#000"
                fillRule="evenodd"
                d="M.625 11.438a.625.625 0 01.625.624v3.126a1.25 1.25 0 001.25 1.25h15a1.25 1.25 0 001.25-1.25v-3.126a.624.624 0 111.25 0v3.126a2.5 2.5 0 01-2.5 2.5h-15a2.5 2.5 0 01-2.5-2.5v-3.126a.625.625 0 01.625-.624z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#000"
                fillRule="evenodd"
                d="M9.557 13.88a.625.625 0 00.885 0l3.75-3.75a.626.626 0 10-.885-.885l-2.682 2.684V.937a.625.625 0 10-1.25 0V11.93L6.692 9.245a.626.626 0 10-.885.885l3.75 3.75z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};

export default React.memo(Download);
